import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { PaymentTermsDataGrid } from "src/components/views/erp/sales/masterData/paymentTerms/PaymentTermsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/paymentTerm")({
	staticData: { title: i18n.t("payment_term"), legacyViewKey: "paymentTermsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <PaymentTermsDataGrid />;
}
